import { useColorPalette } from "../../../hooks/useColorPalette";

export default function TabLabel({ index, selectedTab, setSelectedTab, title }) {
    const palette = useColorPalette();
    
    return (
        <div
            className={`py-2 px-4 rounded-t-lg transition-colors duration-200 ${selectedTab === index ? '' : 'cursor-pointer'}`}
            style={selectedTab === index ? {
                background: `${palette.primary}20`,
                color: palette.primary,
                fontWeight: 600
            } : {}}
            onClick={() => setSelectedTab(index)}
        >
            {title}
        </div>
    )
}